<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">Add Actual Amount for @{{report.instagram}}</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-text-field
          label="Amount"
          v-model.number="amount"
          type="number"
          hide-details
          prefix="S$"
          @input="$v.amount.$touch()"
          :error-messages="amountErrors"
          @blur="$v.amount.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="$v.amount.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-dialog>
</template>
<script>
import campaignAPIs from '../Campaign/campaignAPIs';
import { required } from 'vuelidate/lib/validators';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
// import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  name: 'ActualAmountModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    report: Object
  },
  validations: {
    amount: {
      required
    }
  },
  data () {
    return {
      isLoading: false,
      amount: '',
      paidSearch: ''
    }
  },
  async mounted() {
  },
  computed: {
    amountErrors() {
      const errors = [];
      if (!this.$v.amount.$dirty) return errors;
      !this.$v.amount.required && errors.push('This field is required.');
      return errors;
    }
  },
  methods: {
    save() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          // let updateData = this.payments.map(item => {
          //   let returnObj = {}
          //   returnObj.id = item.id
          //   returnObj.handle = item.instagram
          //   returnObj.campaignID = item.campaignID
          //   returnObj.type = item.type
          //   if (this.data.payment_date !== '') {
          //     returnObj.payment_date = this.data.payment_date
          //   }
          //   if (this.data.payment_status !== this.paymentStatuses.NEW.value) {
          //     returnObj.payment_status = this.data.payment_status
          //   }
          //   if (this.data.bank_reference !== '') {
          //     returnObj.bank_reference = this.data.bank_reference
          //   }
          //   return returnObj
          // })
          const updateData = Object.assign({}, {
            reportID: this.report.reportID,
            campaignID: this.report.campaign.id,
            actualAmount: this.amount
          })
          // Submit request to save edited report data
          this.isLoading = true
          campaignAPIs
          .saveReportActualAmount(this.report.reportID, updateData)
          .then(response => {
            // Update submitting status
            this.isLoading = false;
            this.close()
            // Show success message
            this.$swal({
              text: 'Actual Amount Updated',
              type: 'success'
            });
            this.$emit('updated')
          })
          .catch(error => {
            // Update submitting status
            this.isLoading = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    close() {
      this.$emit('input')
    }
  },
  watch: {
    value: function(newValue) {
      this.amount = ''
      if (this.report) {
        if (this.report.actualAmount) {
          this.amount = this.report.actualAmount
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ActualAmountModal.vue?81aa99f2